import "./index.scss";
import React from "react";
import ReactDOM from "react-dom";

let target = document.body.getAttribute("target");
target = target ? target.trim() : "";
// general

import("lazysizes").then(() => {
  import("./react/userActions").then((userActions) => {
    import("./react/notification");
    searchAutoComplete();
    loadChat();
    menuController();
    dropdownController();
    closenotification();
    userActions.default();
  });
});

switch (target) {
  case "homepage":
    import("./react/carousel");
    import("./rest.js");
    loadMoreAdverts();
    break;
  case "adverts":
    import("./react/custom_filter");
    import("./react/alert");
    filtersController();
    handleFilterSubmit();
    break;
  case "adverts-details":
    import("./advert-details");
    import("./rest.js");
    import("./react/advert-image");
    break;
  default:
    import("./rest.js");
    break;
}

function searchAutoComplete() {
  let searchForm = document.querySelector(".expanding-search-form");
  let searchInputDom = document.getElementById("autocomplete-search");
  let categoriesDropdownDom = document.querySelector(
    ".expanding-search-form .search-dropdown .dropdown-menu"
  );
  let categoriesDropdownToggleDom = document.querySelector(
    ".expanding-search-form .search-dropdown .dropdown-toggle"
  );
  let searchCategoriesTitleDom =
    categoriesDropdownToggleDom.querySelector(".toggle-active");
  let dropdownitem = document.querySelectorAll(
    ".expanding-search-form .search-dropdown .dropdown-menu .dropdown-item"
  );

  if (searchForm) {
    searchForm.addEventListener("submit", () => {
      __gaTracker("send", "event", {
        eventCategory: "Submit Search",
        eventAction: "click",
        eventLabel: window.location.href,
      });
    });
  }
  if (categoriesDropdownToggleDom) {
    categoriesDropdownToggleDom.addEventListener("click", (ev) => {
      categoriesDropdownToggleDom.classList.toggle("--open");
    });
  }
  if (categoriesDropdownDom) {
    categoriesDropdownDom.addEventListener("click", (ev) => {
      const { target } = ev;
      const { href, textContent } = target;

      searchForm.setAttribute("action", href);
      searchCategoriesTitleDom.textContent = textContent;

      ev.preventDefault();
      return false;
    });
  }
  if (dropdownitem) {
    dropdownitem.forEach((dropdown_item) => {
      dropdown_item.addEventListener("click", async (e) =>
        categoriesDropdownToggleDom.classList.remove("--open")
      );
    });
  }
  if (!searchInputDom) {
    return;
  }
  import("./react/search").then((SearchComponent) => {
    import("react").then((React) => {
      import("react-dom").then((ReactDOM) => {
        const placeholderContent = searchInputDom.textContent.trim();
        searchInputDom.style.display = "contents";
        searchInputDom.textContent = "";
        ReactDOM.render(
          <SearchComponent.default placeholder={placeholderContent} />,
          searchInputDom
        );
      });
    });
  });
}

function loadMoreAdverts() {
  const showMoreAdsHomepage = document.getElementById("showMoreAdsHomepage");

  if (showMoreAdsHomepage) {
    showMoreAdsHomepage.addEventListener("click", (ev) => {
      import("../src/script/functions/util").then((util) => {
        let { updateQueryStringParameter } = util;

        let link = showMoreAdsHomepage;
        let page = showMoreAdsHomepage.getAttribute("data-page");
        let url = showMoreAdsHomepage.getAttribute("href");
        let target = showMoreAdsHomepage.getAttribute("target");

        url = updateQueryStringParameter(url, "is_home=1&page", page);

        link.classList.add("loading");

        fetch(url).then(async (data) => {
          const body = await data.text();
          let div = new DOMParser().parseFromString(body, "text/html");
          let copy = div.querySelector(target);
          let more = copy.querySelector(".more-adsoug");

          if (more) {
            more.remove();
          }

          let currentDom = document.querySelector(target);
          currentDom.innerHTML = currentDom.innerHTML + copy.innerHTML;

          link.setAttribute("href", url);
          link.setAttribute("data-page", Number(page) + 1);

          link.classList.remove("loading");
        });
      });

      ev.preventDefault();
      return false;
    });
  }
}

function menuController() {
  const button = document.getElementById("menu__toggle");
  if (button) {
    button.addEventListener("click", (event) => {
      document.getElementById("menu__box").classList.toggle("active_menu");
      document.getElementById("overlay").classList.toggle("hide");
    });
  }

  const close_menu_right = document.getElementById("close_menu_right");
  if (close_menu_right) {
    close_menu_right.addEventListener("click", (event) => {
      document.getElementById("menu__box").classList.toggle("active_menu");
      document.getElementById("overlay").classList.toggle("hide");
    });
  }
}

function dropdownController() {
  let dropdown = document.getElementsByClassName("dropdown_btn");
  let i = 0;
  for (i; i < dropdown.length; i++) {
    dropdown[i].addEventListener("click", function () {
      let dropdownContent = this.nextElementSibling;
      if (dropdownContent.style.display === "block") {
        dropdownContent.style.display = "none";
      } else {
        dropdownContent.style.display = "block";
      }
    });
  }
}

function filtersController() {
  const button_filter = document.getElementById("button_filter");
  if (button_filter) {
    button_filter.addEventListener("click", (event) => {
      document.getElementById("filter_customs").classList.toggle("mymov");
    });
  }

  const close_button_filter = document.getElementById("close_button_filter");
  if (close_button_filter) {
    close_button_filter.addEventListener("click", (event) => {
      document.getElementById("filter_customs").classList.toggle("mymov");
    });
  }

  PriceSliderController();
  areaCityController();
}

function PriceSliderController() {
  let parent = document.querySelector(".price-slider");
  if (!parent) return;
  var rangeS = parent.querySelectorAll("input[type=range]"),
    numberS = parent.querySelectorAll(".rangeslidenumber input[type=text]");

  rangeS.forEach(function (el) {
    el.oninput = function () {
      let slide1 = rangeS[0].value,
        slide2 = rangeS[1].value;
      numberS[0].value = slide1;
      numberS[1].value = slide2;
    };
  });

  numberS.forEach(function (el) {
    el.oninput = function () {
      let number1 = numberS[0].value,
        number2 = numberS[1].value;
      rangeS[0].value = number1;
      rangeS[1].value = number2;
    };
  });
}

function areaCityController() {
  //get area by city
  const areaDom = document.getElementById("area_id");
  const cityDom = document.getElementById("city_id");
  if (areaDom) {
    areaDom.innerHTML = "<option  selected disabled>المنطقه</option>";
  }
  if (cityDom) {
    cityDom.addEventListener("change", function () {
      let uid = this.options[this.selectedIndex].getAttribute("data-value");
      let city_id = uid;
      let areas = "";
      fetch("https://www.alsoug.com/areas-by-city-id/" + city_id)
        .then((res) => res.json())
        .then((res) => {
          res.data.map((data) => {
            areas +=
              "<option value='" + data.slug + "'>" + data.name + "</option>";
            document.getElementById("area_id").innerHTML =
              "<option  value=''>المنطقه</option>" + areas;
          });
        });
    });
  }
}

function closenotification() {
  let close_notification = document.querySelector("#close-notification");
  if (close_notification) {
    close_notification.addEventListener("click", (event) => {
      document.querySelector("#alert-notification").style.display = "none";
    });
  }
}

function loadChat() {
  let chatdom = document.querySelector("#chat");
  if (chatdom) {
    import("./react/chat.js").then((chat) => {
      chat.init();
    });
  }
}

function handleFilterSubmit() {
  const filterForm = document.querySelector("#filters-search-form");

  if (filterForm) {
    filterForm.addEventListener("submit", (ev) => {
      const fields = filterForm.querySelectorAll("[name]");
      const segments = {};
      const queryParams = {};

      __gaTracker("send", "event", {
        eventCategory: "Submit Search",
        eventAction: "filter",
        eventLabel: window.location.href,
      });

      fields.forEach((item) => {
        const { name, value } = item;
        const dataSlug = item.getAttribute("data-slug");
        if (value == "") {
          return;
        }

        if (dataSlug) {
          segments[name] = dataSlug;
          return;
        }

        queryParams[name] = value;
        return;
      });
      const { category, sub_category, city, area } = segments;
      let segmentString = "";

      if (typeof city == "string") {
        segmentString = `${segmentString}/${city}`;
      }
      if (typeof area == "string") {
        segmentString = `${segmentString}/${area}`;
      }
      if (typeof category == "string") {
        segmentString = `${segmentString}/${category}`;
      }
      if (typeof sub_category == "string") {
        segmentString = `${segmentString}/${sub_category}`;
      }

      const url = new URL(`${BASE.url}adverts/السودان${segmentString}`);

      Object.keys(queryParams).forEach((key) => {
        url.searchParams.append(key, queryParams[key]);
      });

      window.open(url.href, "_self");

      ev.preventDefault();
      return false;
    });
  }
}
  if ("serviceWorker" in navigator) {
    // public/v3/dist/browserModern/sw.js
    const sw = `${BASE.urls}/v4/src/script/sw.js`; // it is needed because parcel will not recognize this as a file and not precess in its manner
    navigator.serviceWorker
      .register(sw)
      .then((registration) => {
        registration.onupdatefound = () => {
          const installingWorker = registration.installing;
          if (installingWorker == null) {
            return;
          }
          installingWorker.onstatechange = () => {
            if (installingWorker.state === "installed") {
              if (navigator.serviceWorker.controller) {
              } else {
              }
            }
          };
        };
      })
      .catch((error) => {
        console.error("Error during service worker registration:", error);
      });
  }
